import { type ParsedToken, quoteIfNeeded } from '@gonfalon/dataviz-experimental/QueryBuilder';

import { CONTEXT_KIND_FIELD } from './metricEventFilterFields';

/** Rewrite the query so the pin is a single leading `context:=:<kind>` token (or none). */
export function setContextKindInQuery(parsedQuery: ParsedToken[], kind: string | undefined): string {
  const drop = new Set<number>();
  for (let i = 0; i < parsedQuery.length; i++) {
    const token = parsedQuery[i];
    if (token.type !== 'FILTER' || token.field !== CONTEXT_KIND_FIELD) {
      continue;
    }
    drop.add(i);
    // Prefer trailing connector so clearing the pin doesn't leave a leading AND.
    if (i + 1 < parsedQuery.length && parsedQuery[i + 1].type === 'LOGIC_BOOL') {
      drop.add(i + 1);
    } else if (i > 0 && parsedQuery[i - 1].type === 'LOGIC_BOOL') {
      drop.add(i - 1);
    }
  }

  const cleaned: ParsedToken[] = [];
  for (let i = 0; i < parsedQuery.length; i++) {
    if (drop.has(i)) {
      continue;
    }
    const token = parsedQuery[i];
    if (token.type === 'LOGIC_BOOL') {
      if (cleaned.length === 0 || cleaned[cleaned.length - 1].type === 'LOGIC_BOOL') {
        continue;
      }
    }
    cleaned.push(token);
  }
  while (cleaned.length > 0 && cleaned[cleaned.length - 1].type === 'LOGIC_BOOL') {
    cleaned.pop();
  }

  const remainder = cleaned
    .map((token) => token.text)
    .join(' ')
    .trim();
  const pin = kind ? `${CONTEXT_KIND_FIELD}:=:${quoteIfNeeded(kind)}` : '';
  return [pin, remainder].filter(Boolean).join(' ');
}
